<template>
  <div name="demo-table-row-condition-request">
    <label class="color-skin align-center">Status Approve Condition</label>
    <hrms-table :columns="columns[nowLang].index"
                :data="index"
                :maxRowspan="maxRowspan"
                :indexDisp="true"
                :requestDisp="true"
                :addEvent="addEvent"
                :editEvent="editEvent"
                :cancelEvent="cancelEvent"
                :requestCancelDisp="false"
                :nowLang="nowLang" />

    <label class="color-skin align-center">Status Approve + Custom Condition</label>
    <hrms-table :columns="columns[nowLang].index"
                :data="index"
                :maxRowspan="maxRowspan"
                :indexDisp="true"
                :requestDisp="true"
                :addEvent="addEvent"
                :editEvent="editEvent"
                :cancelEvent="cancelEvent"
                :requestCancelDisp="false"
                :nowLang="nowLang"
                :rowDisableCondition="rowDisableCondition" />
  </div>
</template>

<script>
import mock from './mockTableData.js'

let labels = mock.approveLabels
let flgRowCondition = true
let mockMaxRowspan = 2
let mockColumns = mock.columns(labels, 'display', flgRowCondition)
let mockData = mock.dataApprove(flgRowCondition)

export default {
  name: 'demo-table-row-condition-request',
  data () {
    return {
      nowLang: 'en',
      maxRowspan: mockMaxRowspan,
      columns: {
        en: { index: mockColumns },
        th: { index: mockColumns }
      },
      index: mockData
    }
  },
  methods: {
    addEvent (dataRow) {
      console.log('Add Event')
    },
    editEvent (dataRow) {
      console.log('Edit Event')
    },
    cancelEvent (dataRow) {
      console.log('Cancel Event')
    },
    rowDisableCondition (dataRow) {
      return dataRow.rowID % 3 > 0
    }
  }
}
</script>


// WEBPACK FOOTER //
// demoTableRowConditionRequest.vue?246f26a1